import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, concatMap, take } from 'rxjs';

import { EmployeeProfileService } from '@core/services';
import { ApiCreds, TaxForm } from '@core/models';
import { taxFormDownloadUrl } from './constants';

import * as fileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })
export class TaxFormDownloadService {
  constructor(private employeeProfileService: EmployeeProfileService, private http: HttpClient) {}

  /* Fetch Data from API using Employee API Credentials */
  private fetchData(apiCreds: ApiCreds, taxForm: TaxForm): Observable<Blob> {
    //1. Build URL string
    const url = `${taxFormDownloadUrl}/${apiCreds.bcl}/${apiCreds.id}/${taxForm.fileId}`;

    //2. Fetch URL string and create Observable with Data.
    return this.http.get(url, { responseType: 'blob' });
  }

  private fetchTaxFormDownload(taxForm: TaxForm): Observable<Blob> {
    //* 1. Collect Employee Api Credentials from Profile Service.
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      //2. concatMap to allow inner Observable & fetch Data with apiCreds
      concatMap(apiCreds => this.fetchData(apiCreds, taxForm))
    );
  }

  download(taxForm: TaxForm): void {
    this.fetchTaxFormDownload(taxForm)
      .pipe(take(1))
      .subscribe(response => {
        //#region //* 1. collect taxFormInfo for fileName.
        const fileYear = taxForm.fileYear.toString();
        const stateName = taxForm.stateName;
        const formYear = `taxform_${fileYear}`;
        //#endregion

        //* 2. create fileName.
        const fileName = stateName ? `${formYear}.pdf` : `${formYear}_${stateName}.pdf`;

        //* 3. create new blob.
        const blob = new Blob([response], { type: 'application/pdf' });

        //* 4. save file.
        fileSaver.saveAs(blob, fileName);
      }),
      (error: Error) => console.log('Error downloading the file', error),
      () => console.log('File downloaded successfully');
  }
}
